module.exports = __webpack_public_path__ + "2fce6dc5420051ecaaf8286f361b0ac0.jpg";